module.exports = __webpack_public_path__ + "img/baby4.6d8e9d74.jpg";